// extracted by css-extract-rspack-plugin
export default {"dyBanner":"header-fragment__DynamicYieldHeaderBanner_dyBanner__8MDbr"};